
define('template!ordersDetailDocumentsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="order-documents-region"></div>\n\n<div class="customer-documents">\n    <div class="customer-title">\n        ' +
((__t = ( _.i18n("orderDetail.customer-documents") )) == null ? '' : __t) +
'\n    </div>\n    <div class="customer-documents-region"></div>\n</div>';

}
return __p
};});

